var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8869 8.50002H17.7367M11.8869 4.90238H17.7367M3.88574 6.34143L7.48338 10.6586M7.48338 6.34143L3.88574 10.6586M11.8941 1.48462V12.0977H17.7367",
    stroke: "#368B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04395 12.8171V14.9757C6.04395 15.1666 6.11975 15.3496 6.25469 15.4845C6.38963 15.6194 6.57264 15.6952 6.76347 15.6952H17.0167C17.2076 15.6952 17.3906 15.6194 17.5255 15.4845C17.6605 15.3496 17.7363 15.1666 17.7363 14.9757V2.02422C17.7363 1.83338 17.6605 1.65037 17.5255 1.51543C17.3906 1.38049 17.2076 1.30469 17.0167 1.30469H6.76347C6.57264 1.30469 6.38963 1.38049 6.25469 1.51543C6.11975 1.65037 6.04395 1.83338 6.04395 2.02422V4.1828",
    stroke: "#368B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2664 4.18286H9.46168C9.46168 4.18286 10.1812 4.18286 10.1812 4.90239V12.0977C10.1812 12.0977 10.1812 12.8172 9.46168 12.8172H2.2664C2.2664 12.8172 1.54688 12.8172 1.54688 12.0977V4.90239C1.54688 4.90239 1.54688 4.18286 2.2664 4.18286Z",
    stroke: "#368B00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.22d6bfd45d63d514f5435969734938d4.svg";
export { ForwardRef as ReactComponent };